<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:43:06
 * @LastEditTime: 2022-11-24 09:53:43
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/list.vue
 *
-->
<template>
  <div class="possCommdityLuation">
    <div class="trial_products_warpper">
      <div class="trial_products_header">
        <img
          alt=""
          class="backimg"
          src="@/assets/images/trialProductsList/goback.png"
          @click.stop="goBack"
        />

        <div class="trial_products_commodity">
          <!-- 商品信息 -->
          <div class="trial_products_info">
            <img
              class="trial_products_img"
              :src="commodityData.goodsUrl"
              alt=""
            />
            <div class="commodity_name_box">
              <p class="commodity_name">
                {{ commodityData.goodsName }}
              </p>
              <p class="commodity_name_a">
                商品价格：<span
                  style="font-size: 19px; font-weight: 600; line-height: 19px"
                  >{{ commodityData.goodsPrice }}</span
                >
                元
              </p>
              <p class="commodity_name_people">
                {{ commodityData.goodsNumber }}人已试用
              </p>
            </div>
          </div>
        </div>
        <div class="score-box">
          <div
            class="score"
            v-for="(scoreItem, index) in scoreList"
            :key="index"
          >
            <p>{{ scoreItem.name }}：</p>
            <van-rate
              v-model="scoreItem.score"
              color="#FC616B"
              void-icon="star"
              void-color="#eee"
              :size="16"
              readonly
            />
          </div>
        </div>
      </div>
      <!-- 中奖名单 -->
      <div class="banner_bg" v-if="nameWinnerList20.length > 0">
        <div class="evaluation_list_title"></div>
        <div class="van_list_box">
          <van-list
            class="banner_bg_name_box"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="100"
          >
            <div
              class="banner_bg_name"
              v-for="(item, index) in nameWinnerList20"
              :key="index"
            >
              <img
                alt=""
                class="banner_bg_name_img"
                :src="mateMemberLevel(item.userLevel)"
              />
              <p class="name_winner">{{ item.userName }}</p>
            </div>
          </van-list>
        </div>
      </div>
      <!-- 官方推荐文章 -->
      <div class="official" @click.stop="goDetail(commodityData.pkContent)">
        <div class="evaluation_list_title2"></div>
        <div class="official_box">
          <img :src="commodityData.articleImg" alt="" class="official_img" />
          <div class="official_name_box">
            <p class="official_title">{{ commodityData.articleTitle }}</p>
            <p class="official_ftitle">{{ commodityData.articleSubTitle }}</p>
          </div>
        </div>
      </div>
      <!-- 测评列表 -->
      <pastCommodityList></pastCommodityList>
    </div>
    <div class="submit-box">
      <button class="submit">去购买</button>
      <div class="trap">
        <openWxTag
          id="goToMiniBuyProduct"
          btnStyle="width:100%;height:70px"
          @sensorsFn="goToMiniTo()"
          :path="`/subPackages/shopMainProcess/product/index?productId=${this.commodityData.productId}&skuId=${this.commodityData.skuId}`"
        >
        </openWxTag>
      </div>
    </div>
  </div>
</template>
<script>
//组件
import pastCommodityList from '@/components/contents/trialProductsList/pastCommodityList/index.vue'
import { Debounce, goToMini } from '@/assets/js/common'
import { freetrialView } from '@/utils/freetrialClick.js'
import { BuiedPointClick_Fn } from '@/assets/js/BuriedPointEvent.js'
import openWxTag from '@/components/common/openWeappTag/index.vue'

// 方法
import {
  fomatterNum,
  getCookie,
  isUserEdit,
  isUserLogin,
} from '@/assets/js/common.js'

export default {
  name: 'pastCommodity',
  data() {
    return {
      container: null,
      userInfo: {},
      commodityData: {},
      show: false,
      editFlagTip: false,
      value: 2,
      nameWinnerList: [], //所有数据
      nameWinnerList20: [], //前20条数据
      scoreList: [],
      scoreList2: [
        { name: '评价维度', score: 4 },
        { name: '评价维度', score: 4 },
        { name: '评价维度', score: 4 },
        { name: '评价维度', score: 4 },
        { name: '评价维度', score: 4 },
        { name: '评价维度', score: 4 },
      ],
      officialObj: {
        articleImg: 'https://img01.yzcdn.cn/vant/cat.jpeg',
        articleTitle:
          '30位品监管真实测评，这款大米是真的牛逼啊吃了倒沫子啊哥们儿',
        articleSubTitle: '这期品鉴大会到这里就正式结束啦',
        pkContent: 0,
      },
      loading: false,
      finished: false,
      refreshing: false,
      v1: require('@/assets/images/trialProductsList/v1-member.png'),
      v2: require('@/assets/images/trialProductsList/v2-member.png'),
      v3: require('@/assets/images/trialProductsList/v3-member.png'),
      v4: require('@/assets/images/trialProductsList/v4-member.png'),
      v5: require('@/assets/images/trialProductsList/v5-member.png'),
    }
  },
  components: {
    pastCommodityList,
    openWxTag,
  },
  activated() {},
  created() {
    this.initPage()
  },

  mounted() {
    this.container = this.$refs.container
    this.getTestGoodsDetail()
    console.log('isUserEdit', isUserEdit())
    setTimeout(() => {
      BuiedPointClick_Fn('xmhh5_Freetrial_view', {
        xmhh5_Freetrial_pageview: this.commodityData.goodsName,
      })
    }, 200)
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name != 'milkArticleLists' &&
      to.name != 'historylist' &&
      to.name != 'BabyDetail'
    ) {
      this.$store.commit('changeIncludes', [])
    }
    next()
  },

  methods: {
    isUserLogin,
    fomatterNum,
    getCookie,
    goToMiniTo() {
      BuiedPointClick_Fn('xmhh5_Freetrial_click', {
        xmhh5_freetrial_officialarticle_click: '去购买',
      })
    },
    // 页面初始化
    initPage() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },

    goBack() {
      if (window.history.length > 1 && getCookie('fromPath')) {
        this.$router.go(-1)
      } else {
        this.$router.push({ path: '/home' })
      }
    },
    // 会员等级标识匹配
    mateMemberLevel(userLevel){
      if(userLevel == '铂金'){
        return this.v2
      }else if(userLevel == '钻石'){
        return this.v3
      }else if(userLevel == '星光'){
        return this.v4
      }else if(userLevel == '星耀'){
        return this.v5
      }else{
        return this.v1
      }
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < this.nameWinnerList.length; i++) {
          this.nameWinnerList20.push({
            userLevel: this.nameWinnerList[i].userLevel,
            userName: this.nameWinnerList[i].userName,
          })
        }

        // 加载状态结束
        this.loading = false
        // 数据全部加载完成
        if (this.nameWinnerList20.length >= this.nameWinnerList.length) {
          this.finished = true
        }
      }, 1000)
    },
    // 获取文章列表
    getTestGoodsDetail() {
      this.$http.get(
        '/trial/previous/getPrevious',
        { goodsId: this.$route.params.goodsId },
        (res) => {
          if (res.code === 200) {
            const vote = res.data
            //商品评分列表
            this.scoreList.push({
              name: '商品评价',
              score: res.data.goodsScore,
            })

            this.scoreList = this.scoreList.concat(
              res.data.evaluationDimensionVos
            )

            //黄金会员数据列表
            this.nameWinnerList = res.data.lotteryRosterVos.slice(10, -1)
            this.nameWinnerList20 = res.data.lotteryRosterVos.slice(0, 10)
            //
            //剩余所有
            this.commodityData = {
              goodsName: vote.goodsName,
              goodsUrl: vote.goodsUrl,
              goodsNumber: vote.goodsNumber,
              goodsPrice: vote.goodsPrice,
              productId: vote.productId,
              skuId: vote.skuId,
              articleTitle: vote.articleTitle,
              articleSubTitle: vote.articleSubTitle,
              articleImg: vote.articleImg,
              pkContent: vote.pkContent,
              goodsScore: vote.goodsScore,
            }
            sensors.track('xmhh5_Freetrial_view', {
              xmhh5_Freetrial_pageview: this.commodityData.goodsName,
            })

            console.log(res.data, '评分详情')
          }
        },
        (err) => {
          console.log(err)
        },
        'lucky'
      )
    },
    goDetail: Debounce(function (id) {
      // 跳转测评详情页、
      BuiedPointClick_Fn('xmhh5_Freetrial_click', {
        xmhh5_freetrial_officialarticle_click: '官方推荐测评点击',
      })
      setTimeout(() => {
        this.$router.push({
          path: '/baby/detail/' + id + '?source=home',
        })
      }, 300)
    }),
    getPosition() {
      console.log(commodityData.skuId)
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
